import type { Resource } from '../../';
export const product_sizeChart_measurements_heelToe: Resource = {"default":"Heel-Toe"};
